// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { parseBoolean } from "@stoneage/XDL/Utilities";

export const xIsAuthenticated = (state: ApplicationState): boolean => {
    const session = getSession(state);
    return session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
};

export const isDealer = (state: ApplicationState) => {
    const { isAuthenticated, properties } = getSession(state);

    if (!isAuthenticated) {
        return false;
    }

    const { isDealer } = properties;

    return parseBoolean(isDealer);
};
